import React from 'react'


const BotHeader = () => {
  return (
    <>    
    <div className='botHeder homeHeader'>
    <div className="botHederFon">
      <img src="/static/img/bot/back1.5.png" alt="" />
    </div>
                <div className="homeHeaderText">
                    <h2><i>BAKSBO-BOT</i> увеличит ваши продажи кратно в любой сфере!</h2>                    
                    <p>Профессиональное дикторское озвучивание голосовых ботов для вашего бизнес любой сложности.:</p>
                    <ul>
                      <li>Самостоятельный доступ без ограничений, можете воплощать все, что вам необходимо.</li>
                      <li>Создание под ключ, команда с многолетним опытом все сделает за вас.</li>
                      <li>Подбор базы любой сферы для холодных звонков.</li>
                      <li>Стоимость заявки от 7 руб.</li>
                    </ul>
                    <div className='homeHeaderButtonDiv'>
                        <a href="#bot_tarifs">
                            <button className='getPresent'>Тариф сервиса</button>
                        </a>                  
                    </div>                    
                </div>
                <div className="homeHeaderImage">
                    <img src="/static/img/bot/bot_header_image.png" alt="" />
                </div>
            </div>
    </>
  )
}

export default BotHeader